module.exports = __webpack_public_path__ + "img/ltktravel-3x.d4ea84f.jpg";